export const oneToOneMeetingsListSchema = {
	schema: {
		title: 'one to one meetings schema',
		description: 'create a One to One Meetings schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			app_id_c: {
				type: 'string',
			},
			subject: {
				type: 'string',
			},
			type: {
				type: 'string',
			},
			mobile_no__c: {
				type: 'string',
			},
			user_name_c: {
				type: 'string',
			},
			dealer_code_c: {
				type: 'string',
			},
			dealer_name_c: {
				type: 'string',
			},
			activity_done_at_site_c: {
				type: 'string',
			},
			startdatetime: {
				type: 'string',
			},
			createddate: {
				type: 'string',
				format: 'date-time',
			},
		},
		required: [
			'id',
			'sfid',
			'app_id_c',
			'subject',
			'type',
			'mobile_no__c',
			'user_name_c',
			'dealer_code_c',
			'dealer_name_c',
			'activity_done_at_site_c',
			'startdatetime',
			'createddate',
		],
	},
};
